import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import LearningMenu from '../components/learning/LearningMenu.vue';
import LearningList from '../components/learning/LearningList.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LearningMenu),
    (_unref(route).path === '/learning')
      ? (_openBlock(), _createBlock(LearningList, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})